module.exports = __webpack_public_path__ + "img/ruijin-hospital-logo.fc88ec9f.png";